import { Sheet, styled } from 'tamagui';

export const Grabber = styled(Sheet.Handle, {
  alignSelf: 'center',
  width: 40,
  height: 4,
  backgroundColor: '$borderColor',
});
